<template>
  <div>
    <el-card class="box-card" body-style="min-height:60vh;">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="110px" class="demo-ruleForm">
          <el-form-item label="代理渠道搜索：" prop="name">
            <el-input v-model="searchForm.name" placeholder="请输入代理渠道名称搜索" class="mt-search-width"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button @click="toAdd('')" size="small" type="primary" class="bg-theme">添加代理渠道</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="agentChannelName"
            label="代理渠道名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="toAdd(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <el-dialog
      :title="dataId == '' ? '添加代理渠道' : '编辑代理渠道'"
      :visible.sync="dialogVisible"
      width="960px">
      <el-form :model="cateForm" label-width="140px">
        <el-form-item label="代理渠道名称：" prop="agentChannelName">
          <el-input style="width: 420px;" v-model="cateForm.agentChannelName" placeholder="请输入代理渠道名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { queryAgentChannelPageList, removeAgentChannelById, saveAgentChannel, updateAgentChannel, fetchAgentChannelDetailById } from '@/api/commission'
export default {
  name: 'AgencyChannel',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      baseUrl:this.$baseUrl,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:'',
        region:''
      },
      // 添加分公司弹窗
      dataId:'',
      dialogVisible: false,
      cateForm:{
        agentChannelName:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryAgentChannelPageList({ agentChannelName: searchName,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeAgentChannelById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    /* 跳转添加 */
    toAdd (dataId) {
      this.dataId = dataId
      this.cateForm.agentChannelName = '';
      if(dataId != ''){
        let that = this
        fetchAgentChannelDetailById({ id: dataId }).then((res) => {
          if (res.errorCode === '0000') {
            let data = res.data
            that.cateForm.agentChannelName = data.agentChannelName
          }
        })
      }
      this.dialogVisible = true
    },
    // 添加-编辑
    saveBtn(){
      var that = this
      var dataId = that.dataId
      var agentChannelName = that.cateForm.agentChannelName
      if (agentChannelName === '') {
        this.$message.error('请输入分公司名称')
        return false
      }
      let passData = {
        agentChannelName: agentChannelName
      }
      if (dataId !== '') {
        passData = {
          id: dataId, agentChannelName: agentChannelName
        }
        updateAgentChannel(passData).then((res) => {
          that.fullscreenLoading = false;
          if(res.errorCode == "0000"){
            that.cateForm.dataId = '';
            that.cateForm.agentChannelName = '';
            that.dialogVisible=false;
            that.currentPage = 1;
            that.getInfoList();
          }
          if(res.errorCode == "1001"){
            that.$message.error(res.msg);
          }
        })
      }else{
        saveAgentChannel(passData).then((res) => {
          that.fullscreenLoading = false;
          if(res.errorCode == "0000"){
            that.cateForm.agentChannelName = '';
            that.dialogVisible=false;
            that.currentPage = 1;
            that.getInfoList();
          }
          if(res.errorCode == "1001"){
            that.$message.error(res.msg);
          }
        })
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/commission/AgencyChannel.vue